import Cookies from 'js-cookie';
import SocketService from './SocketService';
import SocketConfig from './SocketConfig';
import HttpService from '../http/HttpService';
import SocketEndpoint from './SocketEndpoint';
import SocketEvent from './SocketEvent';
import EventService from '../event/EventService';

function getJsonCookie(cookie) {
  const existing = Cookies.get(cookie);
  try {
    return JSON.parse(existing);
  } catch (e) {
    return undefined;
  }
}

async function getCredentials() {
  const { data } = await HttpService.get(SocketEndpoint.GET_CREDENTIALS);
  const credentials = { userId: data.userId, jwt: data.jwt };
  Cookies.set(
    SocketConfig.CREDENTIALS_COOKIE,
    JSON.stringify(credentials),
    {
      expires: data.validDays,
      secure: 'true',
    },
  );
  return credentials;
}

async function getAddress() {
  const { data } = await HttpService.get(SocketEndpoint.GET_ADDRESS);
  Cookies.set(SocketConfig.ADDRESS_COOKIE, data.url, { secure: 'true' });
  return data.url;
}

async function getRemoteConnectionData() {
  const credentials = await getCredentials();
  const address = await getAddress();

  return { address, credentials };
}

function getLocalConnectionData() {
  const credentials = getJsonCookie(SocketConfig.CREDENTIALS_COOKIE);
  const address = Cookies.get(SocketConfig.ADDRESS_COOKIE);

  if (address === undefined || credentials === undefined) {
    EventService.dispatch(SocketEvent.NO_LOCAL_CONNECTION_DATA);
    return undefined;
  }

  return { address, credentials };
}

async function establishRemoteConnection() {
  EventService.removeListener(
    SocketEvent.CONNECTION_ERROR,
    { callback: establishRemoteConnection },
  );
  const connectionData = await getRemoteConnectionData();
  SocketService.connect(connectionData);
}

function removeListeners() {
  EventService.removeListener(
    SocketEvent.CONNECTION_ERROR,
    { callback: establishRemoteConnection },
  );

  EventService.removeListener(
    SocketEvent.CONNECTED,
    { callback: removeListeners },
  );

  EventService.removeListener(
    SocketEvent.NO_LOCAL_CONNECTION_DATA,
    { callback: establishRemoteConnection },
  );
}

function addListeners() {
  EventService.addListener(
    SocketEvent.CONNECTED,
    { callback: removeListeners },
  );
  EventService.addListener(
    SocketEvent.CONNECTION_ERROR,
    { callback: establishRemoteConnection },
  );
  EventService.addListener(
    SocketEvent.NO_LOCAL_CONNECTION_DATA,
    { callback: establishRemoteConnection },
  );
}

function connect() {
  removeListeners();
  SocketService.disconnect();

  addListeners();
  const connectionData = getLocalConnectionData();
  if (connectionData !== undefined) {
    SocketService.connect(connectionData);
  }
}

function disconnect() {
  removeListeners();
  SocketService.disconnect();
}

/**
 [Vue migration] Developer Note
 This component has a twin version for both Vue 2 and Vue 3 projects.
 When making changes, remember to update and test both versions.
 */
const SocketCenter = {
  connect,
  disconnect,
};

export default SocketCenter;
